"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonSelector = void 0;

var Point2D_1 = require("../../Core/Point2D");

var RegionData_1 = require("../../Core/RegionData");

var CrossElement_1 = require("../Component/CrossElement");

var Selector_1 = require("./Selector");
/**
 * The selector to define a polygon-region.
 */


var PolygonSelector = /*#__PURE__*/function (_Selector_1$Selector) {
  _inherits(PolygonSelector, _Selector_1$Selector);

  /**
   * Creates new `PolygonSelector` object.
   * @param parent - The parent SVG-element.
   * @param paper - The `Snap.Paper` element to draw on.
   * @param boundRect - The bounding box.
   * @param callbacks - The collection of callbacks.
   */
  function PolygonSelector(parent, paper, boundRect, callbacks) {
    var _this;

    _classCallCheck(this, PolygonSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolygonSelector).call(this, parent, paper, boundRect, callbacks));
    /**
     * Current state of selector.
     */

    _this.isCapturing = false;

    _this.buildUIElements();

    _this.reset();

    _this.hide();

    return _this;
  }
  /**
   * Resizes the selector to specified `width` and `height`.
   * @param width - The new `width`.
   * @param height - The new `height`.
   */


  _createClass(PolygonSelector, [{
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(PolygonSelector.prototype), "resize", this).call(this, width, height);

      this.crossA.resize(width, height);
    }
    /**
     * Hides the selector.
     */

  }, {
    key: "hide",
    value: function hide() {
      _get(_getPrototypeOf(PolygonSelector.prototype), "hide", this).call(this);

      this.hideAll([this.crossA, this.nextPoint, this.nextSegment, this.polygon, this.pointsGroup]);
    }
    /**
     * Shows the selector.
     */

  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(PolygonSelector.prototype), "show", this).call(this);

      this.showAll([this.crossA, this.nextPoint, this.nextSegment, this.polygon, this.pointsGroup]);
    }
    /**
     * Disables and hides this selector.
     */

  }, {
    key: "disable",
    value: function disable() {
      _get(_getPrototypeOf(PolygonSelector.prototype), "disable", this).call(this);

      this.reset();
    }
    /**
     * Builds selector's UI.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      var _this2 = this;

      this.node = this.paper.g();
      this.node.addClass("polygonSelector");
      this.crossA = new CrossElement_1.CrossElement(this.paper, this.boundRect);
      this.nextPoint = this.paper.circle(0, 0, PolygonSelector.DEFAULT_SELECTOR_RADIUS);
      this.nextPoint.addClass("nextPointStyle");
      this.nextSegment = this.paper.g();
      this.nextL1 = this.paper.line(0, 0, 0, 0);
      this.nextLN = this.paper.line(0, 0, 0, 0);
      this.nextL1.addClass("nextSegmentStyle");
      this.nextLN.addClass("nextSegmentStyle");
      this.nextSegment.add(this.nextL1);
      this.nextSegment.add(this.nextLN);
      this.pointsGroup = this.paper.g();
      this.pointsGroup.addClass("polygonGroupStyle");
      this.polygon = this.paper.polygon([]);
      this.polygon.addClass("polygonStyle");
      this.node.add(this.polygon);
      this.node.add(this.pointsGroup);
      this.node.add(this.crossA.node);
      this.node.add(this.nextSegment);
      this.node.add(this.nextPoint);
      var listeners = [{
        event: "pointerenter",
        base: this.parentNode,
        listener: function listener() {
          return _this2.show();
        },
        bypass: false
      }, {
        event: "pointerleave",
        base: this.parentNode,
        listener: function listener(e) {
          if (!_this2.isCapturing) {
            _this2.hide();
          } else {
            var rect = _this2.parentNode.getClientRects();

            var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

            _this2.moveCross(_this2.crossA, p);

            _this2.movePoint(_this2.nextPoint, p);
          }
        },
        bypass: false
      }, {
        event: "pointerdown",
        base: this.parentNode,
        listener: function listener(e) {
          if (!_this2.isCapturing) {
            _this2.isCapturing = true;

            if (typeof _this2.callbacks.onSelectionBegin === "function") {
              _this2.callbacks.onSelectionBegin();
            }
          }
        },
        bypass: false
      }, {
        event: "click",
        base: this.parentNode,
        listener: function listener(e) {
          if (e.detail <= 1) {
            window.requestAnimationFrame(function () {
              var p = new Point2D_1.Point2D(_this2.crossA.x, _this2.crossA.y);

              _this2.addPoint(p.x, p.y);

              _this2.lastPoint = p;
            });
          }
        },
        bypass: false
      }, {
        event: "pointermove",
        base: this.parentNode,
        listener: function listener(e) {
          window.requestAnimationFrame(function () {
            var rect = _this2.parentNode.getClientRects();

            var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

            _this2.moveCross(_this2.crossA, p);

            _this2.movePoint(_this2.nextPoint, p);

            if (_this2.lastPoint != null) {
              _this2.moveLine(_this2.nextLN, _this2.lastPoint, p);

              _this2.moveLine(_this2.nextL1, _this2.points[0], p);
            } else {
              _this2.moveLine(_this2.nextLN, p, p);

              _this2.moveLine(_this2.nextL1, p, p);
            }
          });
          e.preventDefault();
        },
        bypass: false
      }, {
        event: "dblclick",
        base: this.parentNode,
        listener: function listener() {
          return _this2.submitPolygon();
        },
        bypass: false
      }, {
        event: "keyup",
        base: window,
        listener: function listener(e) {
          if (e.code === "Escape") {
            _this2.submitPolygon();
          }
        },
        bypass: true
      }];
      this.subscribeToEvents(listeners);
    }
    /**
     * Resets the selector.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.points = new Array();
      this.lastPoint = null;
      var ps = this.pointsGroup.children();

      while (ps.length > 0) {
        ps[0].remove();
        ps = this.pointsGroup.children();
      }

      this.polygon.attr({
        points: ""
      });

      if (this.isCapturing) {
        this.isCapturing = false;
      }
    }
    /**
     * Adds a new point to polygon at specified coordinates
     * @param x - x-coordinate of the new point.
     * @param y - y-coordinate of the new point.
     */

  }, {
    key: "addPoint",
    value: function addPoint(x, y) {
      this.points.push(new Point2D_1.Point2D(x, y));
      var point = this.paper.circle(x, y, PolygonSelector.DEFAULT_POINT_RADIUS);
      point.addClass("polygonPointStyle");
      this.pointsGroup.add(point);
      var pointsStr = "";
      this.points.forEach(function (p) {
        pointsStr += "".concat(p.x, ",").concat(p.y, ",");
      });
      this.polygon.attr({
        points: pointsStr.substr(0, pointsStr.length - 1)
      });
    }
    /**
     * Submits the new polygon region to the callback function.
     */

  }, {
    key: "submitPolygon",
    value: function submitPolygon() {
      if (typeof this.callbacks.onSelectionEnd === "function") {
        var box = this.polygon.getBBox();
        this.callbacks.onSelectionEnd(new RegionData_1.RegionData(box.x, box.y, box.width, box.height, this.points.map(function (p) {
          return p.copy();
        }), RegionData_1.RegionDataType.Polygon));
      }

      this.reset();
    }
  }]);

  return PolygonSelector;
}(Selector_1.Selector);

exports.PolygonSelector = PolygonSelector;
/**
 * Default radius for the point element. Can be redefined through css styles.
 */

PolygonSelector.DEFAULT_POINT_RADIUS = 3;
/**
 * Default radius for the point element. Can be redefined through css styles.
 */

PolygonSelector.DEFAULT_SELECTOR_RADIUS = 6;